import { useEffect, useState } from 'react';
import api, { RARITY_META, CATEGORY_IMAGES } from '../lib/api';
import { Search as SearchIcon } from 'lucide-react';

export default function Search() {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get('/species', { params: { q, limit: 60 } }).then(r => setRows(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-4" data-testid="search-root">
      <h2 className="font-serif text-3xl">Search Species</h2>
      <div className="flex items-center gap-2 rounded-full bg-card border border-white/5 px-4 py-3">
        <SearchIcon className="w-4 h-4 text-muted-foreground" />
        <input data-testid="search-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Robin, Fox, Chanterelle…" className="bg-transparent outline-none flex-1 text-sm placeholder:text-muted-foreground" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        {rows.map(s => (
          <div key={s.species_id} className="rounded-2xl bg-card border border-white/5 overflow-hidden" data-testid="species-card">
            <div className="aspect-square relative">
              <img src={s.image_url || CATEGORY_IMAGES[s.category]} alt="" className="w-full h-full object-cover" />
              <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-black/60 backdrop-blur text-[9px] uppercase tracking-widest" style={{ color: RARITY_META[s.rarity]?.color }}>{s.rarity}</div>
            </div>
            <div className="p-3">
              <p className="text-sm font-medium truncate">{s.common_name}</p>
              <p className="text-[10px] italic text-muted-foreground truncate">{s.scientific_name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
